<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <div class="spinner-content" :class="isLoading ? 'is-loading' : 'is-hidden'">
        <div class="spinner">
          <div class="double-bounce1" />
          <div class="double-bounce2" />
        </div>
      </div>
      <div v-if="!isLoading && paymentsByInvestor.length === 0" class="message-info has-text-centered">
        <i class="fas fa-exclamation-circle is-pulled-left" />
        <div class="message-text">
          <span>No existen nuevos pagos para remesar</span>
        </div>
      </div>
      <div v-if="!isLoading && paymentsByInvestor.length > 0" id="investors-payments-card" data-cy="investors-payments-card" class="card-item select-content">
        <div class="investor-payments-card-header" data-cy="investor-payments-card-header">
          <h3>Selecciona al inversionista</h3>
          <b-button
            v-if="confirmedTransactions.length > 0"
            id="refresh-button"
            :disabled="!checkUserFeature('element.consignments.button.actualizar-transacciones')"
            rounded
            icon-left="fas fa-sync-alt"
            class="is-button-secondary refresh-button"
            @click="confirmReset">
            Actualizar transacciones
          </b-button>
        </div>
        <div class="investor-content">
          <div
            v-for="({ investor, payments }, i) in paymentsByInvestor"
            :key="`investorPayments${i}`"
            class="investor-item card-item shadowless"
            :class="`investor-${investor.name}`"
            :data-cy="`investor-${investor.name}`">
            <div class="investor-item-info clearfix">
              <div class="text-info">
                <div class="name-content"> {{ investor.name }} </div>
                <div class="fees-content">
                  <span class="text">Nº de cuotas: {{ payments.length }}</span>
                </div>
                <div class="amount-content">
                  <span class="text">$ {{ formatNumber(totalAmountByInvestor[i]) }}</span>
                  <a :id="`copy-button-${investor.name}`" @click.prevent="investor.isValidAmount ? copyToClipBoard(i) : null">
                    <span class="icon">
                      <i v-if="investor.isValidAmount" class="far fa-clone" />
                      <i v-else class="far fa-clone disabledShakeButton disable button-disabled" />
                    </span>
                  </a>
                </div>
                <div class="details-content">
                  <a
                    href="javascript:void(0);"
                    @click.prevent="extendedInvestor = (extendedInvestor !== i) ? i : undefined">
                    <span v-html="extendedInvestor === i ? 'Ocultar ' : 'Ver info '" />
                    <span class="fa fa-chevron-down transition-slow" :class="{rotate: extendedInvestor === i}" />
                  </a>
                </div>
              </div>
            </div>
            <div class="investor-details clearfix transition-slow" :class="{show : extendedInvestor === i}">
              <div class="investor-column">
                <table class="table-data">
                  <tr>
                    <td>Razón social:</td>
                    <td>{{ investor.bankAccount.businessName }}</td>
                  </tr>
                  <tr>
                    <td>Rut:</td>
                    <td>{{ investor.idNumber }}</td>
                  </tr>
                  <tr>
                    <td>Persona de contacto:</td>
                    <td>{{ investor.contact.name }}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td>{{ investor.contact.email }}</td>
                  </tr>
                </table>
              </div>
              <div class="investor-column">
                <table class="table-data">
                  <tr>
                    <td>Banco:</td>
                    <td>{{ investor.bankAccount.bankName }}</td>
                  </tr>
                  <tr>
                    <td>Nº de cuenta:</td>
                    <td>{{ investor.bankAccount.number }}</td>
                  </tr>
                  <tr>
                    <td>Tipo de cuenta:</td>
                    <td>{{ investor.bankAccount.type }}</td>
                  </tr>
                  <tr>
                    <td>Email de confirmación:</td>
                    <td>{{ investor.bankAccount.confirmationEmail }}</td>
                  </tr>
                </table>
              </div>
              <a
                v-if="investor.isValidAmount"
                :disabled="!checkUserFeature('element.consignments.button.confirmar')"
                class="is-pulled-right button is-button-primary confirm-button"
                @click="confirmConsignments">
                <span class="icon"> <i class="fas" :class="buttonIcon" /> </span>
                <span>Confirmar</span>
              </a>
              <a v-else class="is-pulled-right button is-button-primary confirm-button" disabled>
                <b-tooltip multilined label="Inconsistencia en los datos de la remesa. Contactar al equipo de desarrollo." size="is-small" position="is-left" type="is-info">
                  <span>Remesa Bloqueada</span>
                </b-tooltip>
              </a>
            </div>
          </div>
        </div>
        <p v-if="confirmedOperations" id="info-confirmed-transactions" class="datails-confirmed-transactions">
          Hay {{ confirmedOperations }} {{ confirmedOperations > 1 ? 'operaciones' : 'operación' }}
          confirmada{{ confirmedOperations > 1 ? 's' : '' }}
          que no está{{ confirmedOperations > 1 ? 'n' : '' }}
          incluida{{ confirmedOperations > 1 ? 's' : '' }} en la remesa actual,
          <a href="#" @click.prevent="showConfirmedOperations=!showConfirmedOperations">
            revísala{{ confirmedOperations > 1 ? 's' : '' }}</a>.
        </p>
        <div v-if="showConfirmedOperations" class="confirmed-transactions">
          <div v-for="transaction in confirmedTransactions" :key="transaction._id">
            <div v-for="operation in transaction.selectedPayments" :key="operation._id">
              <div v-for="quota in operation.payments" :key="quota._id">
                <div class="card-item confirmed-data">
                  <div class="item">
                    <span class="item-header">Institucional </span>
                    <span class="investor"> {{ quota.investor.name }}</span>
                  </div>
                  <div class="item">
                    <span class="item-header">Fecha de Pago </span>
                    <span class="date">
                      {{ formatDate(transaction.updatedAt, 'DD/MM/YYYY HH:ss') }}
                    </span>
                  </div>
                  <div class="item">
                    <span class="item-header">Rut deudor </span>
                    <span class="id-Number">
                      {{ formatIdNumber(transaction.clientIdNumber) }}
                    </span>
                  </div>
                  <div class="item">
                    <span class="item-header">Monto </span>
                    <span class="transaction-amount">
                      ${{ formatNumber(quota.secondaryCurrencyConsignedAmount) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getConfirmedTransactions, getConsignablePayments, setTransactionsAsConsignable } from '@/application/services/api-clients/transactions';
import { createConsignment } from '@/application/services/api-clients/consignments';
import { dateToFormatedString } from '@/infrastructure/date';
import { formatNumber } from '@/infrastructure/format';
import userFeatures from '@/ui/mixins/user-features';
import Message from '@/ui/components/Message.vue';
import notification from '@/ui/mixins/notification';

export default {
  name: 'Consignments',
  components: { Message },
  mixins: [userFeatures, notification],
  data() {
    return {
      borrame: true,
      currentPayments: [],
      buttonIcon: 'fa-check',
      exportInvestorPayments: [],
      currentPaymentsHeaders: {
        companyOperationId: 'Id CMF',
        clientIdNumber: 'Rut cliente',
        paymentNumber: 'Nº cuota',
        dueDate: 'Fecha vencimiento',
        interest: 'Interés',
        amortization: 'Amortización',
        monthlyPayment: 'Cuota mensual',
        monthlyDebtorLifeInsurance: 'Seguro desgravamen deudor',
        monthlyCodebtorLifeInsurance: 'Seguro desgravamen codeudor',
        monthlyCreditInsurance: 'Seguro crédito',
        monthlyFireInsurance: 'Seguro incendio',
        lateInterest: 'Interés mora',
        lateCharges: 'Gastos cobranza',
        totalMonthlyPayment: 'Recaudado (UF)',
        secondaryCurrencyFactor: 'UF',
        createdAt: 'Fecha de pago',
        secondaryCurrencyTotalMonthlyPayment: 'Recaudado ($)',
        consignedAmount: 'Remesa (UF)',
        secondaryCurrencyConsignedAmount: 'Remesa ($)'
      },
      investorReport: {
        companyOperationId: 'Id Operación CMF',
        paymentNumber: 'Nº de cuota',
        dueDate: 'Fecha de vencimiento',
        interest: 'Interés',
        amortization: 'Amortización',
        monthlyPayment: 'Cuota mensual',
        lateInterest: 'Interés de mora',
        secondaryCurrencyFactor: 'UF',
        createdAt: 'Fecha de pago',
        consignedAmount: 'Remesa (UF)',
        secondaryCurrencyConsignedAmount: 'Remesa ($)'
      },
      isLoading: true,
      extendedInvestor: undefined,
      resetTransactions: false,
      confirmedTransactions: [],
      paymentsByInvestor: [],
      investorDictionary: {
        businessName: 'Razón social',
        idNumber: 'Rut',
        contactName: 'Persona de contacto',
        contactEmail: 'Email',
        bankName: 'Banco',
        accountNumber: 'Nº de cuenta',
        accountType: 'Tipo de cuenta',
        confirmationEmail: 'Email de confirmación'
      },
      showConfirmedOperations: false
    };
  },
  computed: {
    totalAmountByInvestor() {
      return this.paymentsByInvestor.map(({ payments }) => {
        return payments.reduce((total, payment) => total + payment.secondaryCurrencyConsignedAmount, 0);
      });
    },
    confirmedOperations() {
      return this.confirmedTransactions.reduce((i, transaction) => i + transaction.selectedPayments.length, 0);
    }
  },
  async mounted() {
    if (this.$i18n.locale === 'cl') {
      await this.loadConsignablePayments();
    }
  },
  methods: {
    formatDate: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format),
    async refreshConsignablePayments() {
      this.resetTransactions = true;
      await this.loadConsignablePayments();
    },
    async loadConsignablePayments() {
      try {
        this.isLoading = true;
        this.confirmedTransactions = await getConfirmedTransactions();
        if (!this.resetTransactions) {
          this.paymentsByInvestor = await getConsignablePayments();
          if (!this.paymentsByInvestor.length && this.confirmedTransactions.length) {
            await this.refreshConsignablePayments();
          }
          this.isLoading = false;
          this.processInvestorPaymentsToCSV();
          return;
        }
        const transactionsIds = this.confirmedTransactions.map(({ _id }) => _id);
        if (!transactionsIds.length) {
          this.resetTransactions = false;
          this.isLoading = false;
          return;
        }
        await setTransactionsAsConsignable(transactionsIds);
        this.resetTransactions = false;
        this.loadConsignablePayments();
      } catch (_error) {
        this.alert({ message: 'Hubo un problema al comunicarnos con el servidor.', alertType: 'is-danger' });
      }
    },
    confirmReset() {
      const plural = this.confirmedTransactions.length !== 1;
      this.$buefy.dialog.confirm({
        title: '¿Seguro?',
        message: `Hay ${this.confirmedTransactions.length}
         ${plural ? 'transacciones' : 'transacción'}
         confirmada${plural ? 's' : ''} que no
         está${plural ? 'n' : ''}
         incluida${plural ? 's' : ''}
         en la remesa, ¿seguro que quieres considerarla${plural ? 's' : ''}?`,
        cancelText: 'No',
        confirmText: 'Sí',
        type: 'is-danger',
        onConfirm: this.refreshConsignablePayments
      });
    },
    totalAmountByOperation(payments) {
      return payments.reduce((total, payment) => total + payment.secondaryCurrencyConsignedAmount, 0);
    },
    formatNumber: number => formatNumber({ number }),
    formatIdNumber(idNumber) {
      const splittedIdNumber = idNumber.split('-');
      return `${this.formatNumber(Number(splittedIdNumber[0]))}-${splittedIdNumber[1]}`;
    },
    floatFormat(number) {
      return formatNumber({
        number,
        thousandSeparator: '.',
        groupOfDigitsLength: 3,
        decimalSeparator: ',',
        minDecimals: 0,
        maxDecimals: 6
      });
    },
    confirmConsignments() {
      const investorIndex = this.extendedInvestor;
      this.$buefy.dialog.confirm({
        title: 'Confirmar transferencia',
        message: `¿Efectivamente transferiste el monto $ ${this.formatNumber(this.totalAmountByInvestor[investorIndex])}
          del inversionista ${this.paymentsByInvestor[investorIndex].name}?`,
        cancelText: 'Cancelar',
        confirmText: 'Confirmar',
        type: 'is-info',
        onConfirm: this.postConsign
      });
    },
    async postConsign() {
      const investorIndex = this.extendedInvestor;
      this.buttonIcon = 'fa-spinner fa-spin';
      try {
        await createConsignment(this.paymentsByInvestor[investorIndex].payments);
        await this.loadConsignablePayments();
        this.alert({ message: 'Transferencia confirmada correctamente', alertType: 'is-info' });
        this.extendedInvestor = undefined;
        this.currentPayments = [];
        this.buttonIcon = 'fa-check';
      } catch (_error) {
        this.buttonIcon = 'fa-check';
        this.alert({ message: 'Ha ocurrido un error al tratar de confirmar la transferencia', alertType: 'is-warning' });
      }
    },
    processInvestorPaymentsToCSV() {
      const headerKeys = Object.keys(this.currentPaymentsHeaders);
      this.exportInvestorPayments = this.paymentsByInvestor.map(({ payments }) => {
        return payments.map(investorPaymentIn => {
          const row = {};
          const investorPayment = JSON.parse(JSON.stringify(investorPaymentIn));
          // enteros
          investorPayment.secondaryCurrencyConsignedAmount = this.floatFormat(investorPayment.secondaryCurrencyConsignedAmount);
          investorPayment.secondaryCurrencyFactor = this.floatFormat(investorPayment.secondaryCurrencyFactor);
          investorPayment.secondaryCurrencyTotalMonthlyPayment = this.floatFormat(investorPayment.secondaryCurrencyTotalMonthlyPayment);
          // uf
          investorPayment.amortization = this.floatFormat(investorPayment.amortization);
          investorPayment.consignedAmount = this.floatFormat(investorPayment.consignedAmount);
          investorPayment.interest = this.floatFormat(investorPayment.interest);
          investorPayment.lateCharges = this.floatFormat(investorPayment.lateCharges);
          investorPayment.lateInterest = this.floatFormat(investorPayment.lateInterest);
          investorPayment.monthlyFireInsurance = this.floatFormat(investorPayment.monthlyFireInsurance);
          investorPayment.monthlyCodebtorLifeInsurance = this.floatFormat(investorPayment.monthlyCodebtorLifeInsurance);
          investorPayment.monthlyDebtorLifeInsurance = this.floatFormat(investorPayment.monthlyDebtorLifeInsurance);
          investorPayment.monthlyCreditInsurance = this.floatFormat(investorPayment.monthlyCreditInsurance);
          investorPayment.monthlyPayment = this.floatFormat(investorPayment.monthlyPayment);
          investorPayment.totalMonthlyPayment = this.floatFormat(investorPayment.totalMonthlyPayment);
          // fechas
          investorPayment.createdAt = dateToFormatedString(investorPayment.createdAt, 'DD/MM/YYYY');
          const dueDateSplit = investorPayment.dueDate.split('-');
          investorPayment.dueDate = `${dueDateSplit[2]}/${dueDateSplit[1]}/${dueDateSplit[0]}`;

          headerKeys.forEach(key => {
            row[this.currentPaymentsHeaders[key]] = investorPayment[key];
          });
          return row;
        });
      });
    },
    copyToClipBoard(investor) {
      const filteredData = this.exportInvestorPayments[investor];
      const lines = [Object.keys(filteredData[0]).join('\t')];
      filteredData.forEach(investorPayments => {
        lines.push(Object.values(investorPayments).join('\t'));
      });
      const textToCopy = lines.join('\n');
      this.$copyText(textToCopy).then(result => {
        this.shakeButton(this.paymentsByInvestor[investor].investor.name);
        this.$emit('copySuccess', result);
      }).catch(error => {
        this.$emit('copyError', error);
      });
    },
    shakeButton(investorName) {
      const element = this.$el.querySelector(`#copy-button-${investorName}`);
      element.classList.remove('shaking');
      // eslint-disable-next-line no-unused-expressions
      element.offsetWidth;
      element.classList.add('shaking');
    }
  }
};
</script>
<style lang="css" scoped>
  .investor-payments-card-header{
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
  }
  .message-info {
    display: grid;
    grid-template-columns: 1fr 10fr;
    gap: 1rem;
    align-items: center;
    background: #F2FBFB;
    padding: 20px;
    margin: 0.5rem 0rem 2rem 0rem;
    border-radius: 20px;
    font-family: var(--secondary-font);
    color: var(--color-nickel);
  }
  .message-info i {
    color: var(--primary);
  }
  .confirmed-data {
    display: grid;
    grid-gap: 1rem;
    grid-template:
      1fr
      / 1fr 1fr 1fr 1fr;
    text-align: center;
    font-size: 0.8rem;
    margin-top: 1rem;
  }
  .item {
    display: grid;
    grid-gap: 0.5rem;
    grid-template:
      1fr 1fr
      / 1fr;
    text-align: center;
    font-size: 0.8rem;
  }
  .item-header {
    color: var(--primary);
  }
  .confirm-button {
    padding: 10px;
    height: auto;
    border-radius: 20px;
    border: inherit;
    font-size: 10px;
    text-decoration: none;
    font-weight: 400;
    font-family: var(--primary-font);
    margin-top: 20px;
  }
  .button-disabled {
    opacity: 40%
  }
  .spinner-content {
    margin-top: 80px;
  }
  .select-content {
    margin-top: 3rem;
    padding-bottom: 50px;;
    overflow: inherit;
  }
  .table-content {
    width: 95%;
    margin: 30px auto 50px;
  }
  .b-table .table-wrapper.has-sticky-header {
    height: auto;
  }
  .investor-item {
    padding: 14px 29px;
    margin: 20px auto;
    border-radius: 25px;
    position: relative;
    overflow: inherit;
    width: 100%;
  }
  .text-info {
    display:flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
  }
  .rotate {
    transform: rotate(180deg);
  }
  .name-content {
    color: var(--primary);
    font-size: 18px;
    font-weight: 600;
  }
  .amount-content a {
    display: inline-block;
    margin-left: 15px;
  }
  .investor-details{
    width: 100%;
    max-height: 0px;
    height: auto;
    overflow: hidden;
    margin: auto;
    background-color: #F9F9F9;
    border-radius: 20px;
    padding: 0 30px;
    margin-top: 0px;
  }
  .investor-details.show{
    margin-top: 10px;
    padding: 20px;
    max-height: 300px;
  }
  .investor-column {
    width: 50%;
    float: left;
  }
  .table-data{
    width: 100%;
    font-size: 11px;
    vertical-align: bottom !important;
  }
  .table-data tr td:first-child{
    color: var(--primary);
    width: 40%;
  }
  table .important-color{
    color: var(--secondary);
    font-size: 14px;
  }
  .round-choice-content {
    width: 25px;
    float: left;
  }
  .details-content{
    float: right;
  }
  .details-content a {
    text-decoration: none;
    font-size: 16px;
  }
  .shaking {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
  .disabledShakeButton {
    color: var(--color-nickel);
    cursor: not-allowed;
  }
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
  @media (max-width: 1250px){
    .text-item-info {
      width: 30%;
    }
    .text-item-info:first-child {
      width: 50%;
    }
    .details-content a span:first-child {
      display: none;
    }
  }
  @media (max-width: 850px){
    .text-item-info {
      white-space: nowrap;
    }
    .investor-column {
      float: none;
      width: 100%;
    }
    .table-data tr td:first-child {
      width: 50% !important;
    }
  }
  @media (max-width: 640px){
    .text-info{
      display: block;
      text-align: center;
    }
    .text-item-info{
      width: 100%;
      margin-bottom: 10px;
    }
    .round-choice-content {
      position: absolute;
      width: 35px;
      height: 35px;
      right: 20px;
      top: 20px;
    }
    .details-content {
      text-align: center;
      width: 100%;
    }
    .table-data {
      font-size: 9px;
    }
    .table-data .tr .td:nth-child(2)::before {
      content: "\A";
    }
    .confirmed-data {
    display: grid;
    grid-gap: 0.5rem;
    grid-template:
      1fr 1fr 1fr 1fr
      / 1fr;
    text-align: center;
    font-size: 0.8rem;
    }
    .item {
      display: grid;
      grid-gap: 0.5rem;
      grid-template:
        1fr
        / 1fr 1fr;
      text-align: left;
      font-size: 0.8rem;
    }
  }
</style>
